import { Button, Grid, Paper } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';
import { useEffect } from 'react';
// import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useState } from 'react';

import {
    // fetchExperts,
    fetchMissionExperts
} from '../../Api/suiviMission/experts';
import CollaboratorsList from '../../Components/suiviMission/CollaboratorsList';
import HeaderBar from '../../Components/suiviMission/HeaderBar';
import AddExpertModal from '../../Components/suiviMission/modals/AddExpertModal';
import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';

const CollaboratorsSuiviMission = () => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [list, setlist] = useState([]);
    const { mission } = useGlobalContext();
    // Get the collaborators in this mission
    useEffect(() => {
    // fetchExperts(setlist);
        fetchMissionExperts(setlist);
    }, []);

    useEffect(() => {
        console.log('collaboratorssuiviMission', list);
    }, [list]);

    return (
        <Box
            sx={{ width: '100%',
                position: 'relative',
                top: '110px', //* comment this top if you want this navBar to replace the other (older)
                zIndex: '10' }}
        >
            <HeaderBar title={'Experts '} />
            <Paper
                elevation={3}
                className="my-3 "
                square="true"
                sx={{
                    borderRadius: '1.5rem',
                    height: '100%',
                    margin: '10px',
                    padding: '20px',
                }}
            >
                <Grid container>
                    <Grid
                        item
                        xs={12}
                    >
                        {/* this section can be used later to add a collaborator  */}
                        {/* <Box
              sx={{
                backgroundColor: "inherit",
                marginTop: "10px",
                marginRight: "15px",
              }}
            >
              <Grid container justifyContent="flex-end" alignItems="flex-end">
                <Grid item>
                  <Button
                    variant="contained"
                    endIcon={<AddCircleIcon />}
                    color="primary"
                    onClick={handleOpen}
                  >
                    Nouveau Collaborateur
                  </Button>
                  <AddExpertModal open={open} handleClose={handleClose} />
                </Grid>
              </Grid>
            </Box> */}
                    </Grid>

                    <Grid
                        item
                        xs={12}
                    >
                        <Box
                            sx={{
                                backgroundColor: 'inherit',
                                marginTop: '10px',
                                marginRight: '15px',
                            }}
                        >
                            <Grid
                                container
                                justifyContent="flex-end"
                                alignItems="flex-end"
                            >
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            // Todo
                                            setlist([]);
                                        }}
                                    >
                    Projet
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        onClick={() => {
                                            //set list to mission experts
                                            fetchMissionExperts(setlist, mission._id);
                                        }}
                                    >
                    Mission
                                    </Button>
                                    {/* <Button
                    variant="outlined"
                    onClick={() => {
                      //set list to mission experts
                      fetchExperts(setlist);
                    }}
                  >
                    Tous les experts
                  </Button> */}
                                    <Grid
                                        container
                                        justifyContent="flex-end"
                                        alignItems="flex-end"
                                    >
                                        <Grid item>
                                            <button
                                                onClick={handleOpen}
                                                style={{
                                                    borderRadius: '4px',
                                                    backgroundColor: '#19223F',
                                                    color: '#FFFFFF',
                                                    border: 'none',
                                                    padding: '8px',
                                                    fontSize: '13px',
                                                }}
                                            >
                        Nouveau Expert
                                            </button>
                                            <AddExpertModal
                                                open={open}
                                                handleClose={handleClose}
                                            />
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                </Grid>
                <CollaboratorsList list={list} />
            </Paper>
        </Box>
    );
};

export default CollaboratorsSuiviMission;
